import * as React from 'react';
import { Evaluation } from '../../models/Evaluation';
import { StoryInfo } from '../../models/Story';

export interface StatusProps {
	evaluations: Evaluation[];
	stories: StoryInfo[];
	bigIcons: boolean;
}

export const Status: React.SFC<StatusProps> = (props) => {
	let evals = [];
	for(let i = 0; i < props.evaluations.length; i++){
		if(props.evaluations[i].amount){

			let evalsMade = 0;
			for(let j = 0; j < props.stories.length; j++){
				if(props.stories[j].evaluations.find(evaluation => evaluation.name == props.evaluations[i].name)){
					evalsMade++;
				}
			}

			let green = (evalsMade >= props.evaluations[i].amount ? " am_green" : "");
			const evalWrapper = props.bigIcons ? 'am_evalwrapper' : 'am_small-evalwrapper';
			const mainClassName = props.bigIcons ? 'am_evalwamount' : 'am_small-evalwamount';
			const numberSize = props.bigIcons ? 'am_big-number' : 'am_number';

			evals.push(
				<div className={evalWrapper}>
					<div className={mainClassName}>
						<img src={props.evaluations[i].image}></img>
						<div className={numberSize + green}>{evalsMade}/{props.evaluations[i].amount}</div>
					</div>
					<div className={"am_name"}>{props.evaluations[i].name}</div>
				</div>
			);
		}
	}

	return (
			<div>
				{evals}
			</div>
		);
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Campaign/status.tsx